import React from 'react';
import MobileMainLayout from '../../layout/MobileMainLayout';

const Mug = () => {
  return (
    <MobileMainLayout link="javascript:;" title="Mug">
      Working on it...
      {/* <FootwearBanner />
      <div className="mb-3">
        <ShopByCategoryFootwear title="Trending Mug Categories" />
      </div> */}
    </MobileMainLayout>
  );
};

export default Mug;
